export const ABCS_DEFAULT_VIEWABILITY_BIN = 'GROSS';

// Shared by the ABCS and Accretive exports. Same bins as attribution V3:
// Gross drops decayed exposures; Decay keeps everything, decayed included.
export const ABCS_VIEWABILITY_OPTIONS = Object.freeze([
  { label: 'Gross', value: 'GROSS' },
  { label: 'OTS (Viewable)', value: 'VIEWABLE' },
  { label: 'LTS (Effective)', value: 'EFFECTIVE' },
  { label: 'Decay (all, incl. decayed)', value: 'DECAYED' },
]);

export const ABCS_CSV_COLUMN_OPTIONS = Object.freeze([
  { label: 'Device Hash (SHA-256)', value: 'DEVICE_HASH' },
  { label: 'Inventory Class', value: 'INVENTORY_CLASS', note: 'Stationary, Transit, Place-Based' },
  { label: 'Inventory Type', value: 'INVENTORY_TYPE', note: 'Billboard, Street-Level, etc.' },
  { label: 'Inventory Subtype', value: 'INVENTORY_SUBTYPE', note: 'Bulletin, Digital Kiosk, Bus 300x250, etc.' },
  { label: 'Campaign Ref', value: 'CAMPAIGN_REF' },
  { label: 'Ad Group (Flight Ref)', value: 'AD_GROUP' },
  { label: 'Media Product', value: 'MEDIA_PRODUCT' },
  { label: 'Inventory Format', value: 'INVENTORY_FORMAT', note: 'Static or Digital' },
  { label: 'Market Name', value: 'MARKET_NAME' },
  { label: 'DMA Code', value: 'DMA_CODE' },
  { label: 'Creative Ref', value: 'CREATIVE_REF', note: 'StreetMetrics Creative Name' },
  { label: 'Creative Display Name', value: 'CREATIVE_DISPLAY_NAME' },
  { label: 'Timestamps', value: 'TIMESTAMPS', note: 'Unix 10-digit' },
  { label: 'Inventory Ref (Unit ID)', value: 'INVENTORY_REF' },
]);

export function getDefaultAbcsCsvColumns() {
  return ABCS_CSV_COLUMN_OPTIONS.map(column => column.value);
}

export function getAbcsCsvColumnsInOrder(columns) {
  const selectedColumns = new Set(Array.isArray(columns) ? columns : []);

  return ABCS_CSV_COLUMN_OPTIONS
    .map(column => column.value)
    .filter(column => selectedColumns.has(column));
}
